<script>
    import QuestionText from '../QuestionText/QuestionText.svelte';
    import MultipleChoiceQuestion from '../MultipleChoiceQuestion/MultipleChoiceQuestion.svelte';
    import MultipleResponseQuestion from '../MultipleResponseQuestion/MultipleResponseQuestion.svelte';
    import MatrixQuestion from '../MatrixQuestion/MatrixQuestion.svelte';
    import OpenQuestion from '../OpenQuestion/OpenQuestion.svelte';
    import YesNoQuestion from '../YesNoQuestion/YesNoQuestion.svelte';
    import { beforeUpdate } from 'svelte';
    import {questionAnswers} from '../../stores';
    import {QuestionAnswer} from '../../models/QuestionAnswer';
     

    export let question = {};

    /**
     * set true if you do not want answer to be displayed, useful when e.g. printing survey
     * @type {boolean}
     */
    export let hideAnswer = false;

    beforeUpdate(() => {
        // make sure we have an answer object to populate
        const a = $questionAnswers.find(a => a.questionId === question.questionId);
        if (!a) {
            const newAnswer = new QuestionAnswer({questionId: question.questionId});
            questionAnswers.update(currentAnswers => {currentAnswers = [...currentAnswers, newAnswer]; return currentAnswers;});
        }
    });
</script>


<!-- The question text should ideally be short and then we could use fieldset with legend... -->
<QuestionText question={question} />

{#if question.type === 'MultipleChoice' && question.maxAlternativesToSelect === 1}
    <MultipleChoiceQuestion {question} {hideAnswer} />
{:else if question.type === 'MultipleChoice'}
    <MultipleResponseQuestion {question} {hideAnswer} />
{:else if question.type === 'Matrix'}
    <MatrixQuestion {question} {hideAnswer} />
{:else if question.type === 'YesNo'}
    <YesNoQuestion {question} {hideAnswer} />
{:else if question.type === 'Open'}
    <OpenQuestion {question} {hideAnswer} />
{/if}
